module.exports = __webpack_public_path__ + "img/18_98.2a8ee57e.png";